import React from 'react';
import { useTranslation } from 'react-i18next';
import { SwiperSlide, Swiper } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css/bundle';
import usePartners from '../../hooks/usePartners';

const PartnerLogos = () => {
    const { t } = useTranslation();
    const { home } = t("screen");

    const { partners, isLoaded } = usePartners();

    // Hide the whole section until we know one way or the other, and
    // permanently if there are no real partners set up in the admin
    // panel - no placeholder content, no flash of an empty carousel.
    if (!isLoaded || partners.length === 0) {
        return null;
    }

    return (
        <section className="ms-partner-area fix pt-50 pb-100">
            <div className="container">
                <div className="section__title-wrapper mb-20 text-center bd-title-anim">
                    <span className="section__subtitle" style={{ fontFamily: 'Oregano-Italic, sans-serif', textTransform: "none" }}>{home?.partnersSubtitle}</span>
                    <h2 className="section__title" style={{ fontFamily: 'Prompt-Regular, sans-serif', textTransform: "none" }}>{home?.partnersTitle}</h2>
                </div>

                <div className="ms-partner-active">
                    <Swiper
                        modules={[Autoplay]}
                        rewind={true}
                        spaceBetween={30}
                        slidesPerView={5}
                        autoplay={{ delay: 4000, disableOnInteraction: false }}
                        speed={5000}
                        observeParents={true}
                        observer={true}
                        breakpoints={{
                            1200: { slidesPerView: 5 },
                            992: { slidesPerView: 4 },
                            768: { slidesPerView: 3 },
                            576: { slidesPerView: 2 },
                            0: { slidesPerView: 1 },
                        }}
                    >
                        {partners.map((item) => (
                            <SwiperSlide key={item.id || item._id}>
                                <div className="ms-partner-tile">
                                    {item.logoUrl && (
                                        <img src={item.logoUrl} loading="lazy" alt={item.name || "partner logo"} />
                                    )}
                                    <span className="ms-partner-name">{item.name}</span>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default PartnerLogos;
